"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_COMBINATION_COUNT = exports.getCombinationsCount = void 0;
const getCombinationsCount = (length, count) => {
    const range = (from, to) => Array.from({ length: to - from }, (_, index) => index + from);
    const max = Math.max(count, length - count);
    const min = Math.min(count, length - count);
    const divisor = range(max + 1, length + 1).reduce((acc, n) => acc * n, 1);
    const divider = range(1, min + 1).reduce((acc, n) => acc * n, 1);
    return divisor / divider;
};
exports.getCombinationsCount = getCombinationsCount;
exports.MAX_COMBINATION_COUNT = 100;
//# sourceMappingURL=systemCombination.js.map